import * as React from 'react';

import localStorageEx from 'bundles/common/utils/localStorageEx';
import { useDegreeMetadataContext } from 'bundles/degree-home/components/v3-dpm/context/DegreeMetadataContext';

export const DEGREE_AUDIT_DISCLAIMER = 'show_degree_audit_disclaimer';

const PARTNER = {
  BOULDER: 71,
};

const PARTNERS_WITH_DISCLAIMER = [PARTNER.BOULDER];

interface PartnerVariationContext {
  showDegreeAuditDisclaimer: boolean;
  setDontShowDisclaimer: () => void;
}
const partnerVariationContext = React.createContext<PartnerVariationContext>({
  showDegreeAuditDisclaimer: false,
  setDontShowDisclaimer: () => {},
});

export const usePartnerVariation = () => React.useContext(partnerVariationContext);

export const PartnerVariationProvider: React.FC<{ __overrideForStorybook?: PartnerVariationContext }> = ({
  children,
  __overrideForStorybook,
}) => {
  const { Provider } = partnerVariationContext;
  const degree = useDegreeMetadataContext();

  const degreeId = degree.degreeMetadata?.id;
  const partnerId = degree.degreeMetadata?.partnerIds[0];

  const setDontShowDisclaimer = () => {
    localStorageEx.setItem(`${DEGREE_AUDIT_DISCLAIMER}-${degreeId}`, false, JSON.stringify);
  };

  if (__overrideForStorybook) {
    return <Provider value={__overrideForStorybook}>{children}</Provider>;
  }
  const showDisclaimerForPartner = partnerId ? PARTNERS_WITH_DISCLAIMER.includes(partnerId) : false;

  const showDisclaimerLocalStorage = degreeId
    ? localStorageEx.getItem(`${DEGREE_AUDIT_DISCLAIMER}-${degreeId}`, JSON.parse, true, false, false)
    : false;

  const showDegreeAuditDisclaimer = showDisclaimerForPartner && showDisclaimerLocalStorage;

  return <Provider value={{ showDegreeAuditDisclaimer, setDontShowDisclaimer }}>{children}</Provider>;
};
